//
// Copyright (c) 2011-2024 by Curalate, Inc.
//

import { useSelector } from 'react-redux';

import { getIsInfluencersDiscoveryEnabled } from '@influencers/selectors/getInfluencersLists';
import { SocialNetwork } from '@models/SocialNetwork';
import { getIsShareV2Vendor } from '@redux/selectors/getSessionInfo';

export const useShouldRouteToExternal = (socialNetwork: SocialNetwork) => {
  const isShareV2Vendor = useSelector(getIsShareV2Vendor);

  const isInfluencersDiscoveryEnabled = useSelector(
    getIsInfluencersDiscoveryEnabled,
  );

  const shouldLinkExternalTikTok =
    !isInfluencersDiscoveryEnabled && socialNetwork === SocialNetwork.TikTok;

  return (
    isShareV2Vendor ||
    shouldLinkExternalTikTok ||
    socialNetwork === SocialNetwork.Facebook
  );
};
